import { useEffect, useState } from 'react'
import { PromotionsProp } from 'models/sectionPromotions'
import { getPromotions } from 'services/promotions'

export const usePromotionController = () => {
  const [dataPromotions, setPromotions] = useState<PromotionsProp>([])
  const [loadingPromo, setLoading] = useState(true)

  useEffect(() => {
    getPromotions().then(data => {
      setPromotions(data)
      setLoading(false)
    })
  }, [])

  return {
    dataPromotions,
    loadingPromo,
  }
}
